// App.js - WEB
import React, { Component } from 'react';
import { View } from 'react-native';
import firebase from 'firebase';
import { connect } from 'react-firebase';
import { BuilderProvider } from '@builder/component-library';
import { Outlet, useLocation } from 'react-router-dom';
import { WebRoutesGenerator } from '../../components/src/NavigationRouteWrapper/Web';
import HomeScreen from '../../components/src/HomeScreen';
import TopNav from '../../components/src/TopNav';
import InfoPage from '../../blocks/info-page/src/InfoPageBlock';
import AlertBlock from '../../blocks/alert/src/AlertBlock';
import AdvancedSearch from "../../blocks/advancedsearch/src/AdvancedSearch";
import Sorting from "../../blocks/sorting/src/Sorting";
import Filters from "../../blocks/filteritems/src/Filters.web";
import Filteritems from "../../blocks/filteritems/src/Filteritems";
import Filteroptions from "../../blocks/filteritems/src/Filteroptions";
import ForgotPassword from "../../blocks/mobile-account-login/src/ForgotPassword.web";
import ResetPassword from "../../blocks/mobile-account-login/src/ResetPassword.web";
import ForgotPasswordOTP from "../../blocks/forgot-password/src/ForgotPasswordOTP";
import NewPassword from "../../blocks/forgot-password/src/NewPassword";
import SocialMediaAccountLogin from "../../blocks/social-media-account/src/SocialMediaAccountLogin";
import SocialMediaAccountRegistration from "../../blocks/social-media-account/src/SocialMediaAccountRegistration";
import Rolesandpermissions2 from "../../blocks/rolesandpermissions2/src/Rolesandpermissions2";
import Cometchatintegration from "../../blocks/cometchatintegration/src/Cometchatintegration";
import CountryCodeSelector from "../../blocks/country-code-selector/src/CountryCodeSelector";
import Contactus from "../../blocks/contactus/src/Contactus";
import AboutUs from "../../blocks/navigationmenu/src/AboutUs.web"
import AddContactus from "../../blocks/contactus/src/AddContactus";
import Emailnotifications2 from "../../blocks/emailnotifications2/src/Emailnotifications2";
import MobileAccountLoginBlock from "../../blocks/mobile-account-login/src/MobileAccountLoginBlock";
import MyOrders from "../../blocks/ordermanagement/src/MyOrders.web";
import OrderManagement from "../../blocks/ordermanagement/src/OrderManagement";
import Settings2 from "../../blocks/settings2/src/Settings2.web";
import OrderReview from "../../blocks/ordermanagement/src/OrderReview.web";
import Pushnotifications from "../../blocks/pushnotifications/src/Pushnotifications";
import TermsConditions from "../../blocks/termsconditions/src/TermsConditions.web";
import PrivacyPolicy from "../../blocks/termsconditions/src/PrivacyPolicy.web";
import TermsConditionsDetail from "../../blocks/termsconditions/src/TermsConditionsDetail";
import TermsConditionsUsers from "../../blocks/termsconditions/src/TermsConditionsUsers";
import LandingPage from "../../blocks/landingpage/src/LandingPage";
import AccountGroups from "../../blocks/accountgroups/src/AccountGroups";
import NavigationMenu from "../../blocks/navigationmenu/src/NavigationMenu";
import EmailAccountRegistration from "../../blocks/email-account-registration/src/EmailAccountRegistration";
import EmailVerification from "../../blocks/email-account-registration/src/EmailVerification.web";
import OTPInputAuth from "../../blocks/otp-input-confirmation/src/OTPInputAuth";
import Blockedusers from "../../blocks/blockedusers/src/Blockedusers";
import AddBlockeduser from "../../blocks/blockedusers/src/AddBlockeduser";
import BulkUploading from "../../blocks/bulkuploading/src/BulkUploading";
import SubscriptionPlans from "../../blocks/customisableusersubscriptions/src/SubscriptionPlans.web";
import Customisableusersubscriptions from "../../blocks/customisableusersubscriptions/src/Customisableusersubscriptions";
import SubscriptionDetails from "../../blocks/customisableusersubscriptions/src/SubscriptionDetails";
import Categoriessubcategories from "../../blocks/categoriessubcategories/src/Categoriessubcategories";
import Catalogue from "../../blocks/catalogue/src/Catalogue";
import Analytics from "../../blocks/analytics/src/Analytics";
import EmailAccountLoginBlock from "../../blocks/email-account-login/src/EmailAccountLoginBlock";
import Uploadmedia3 from "../../blocks/uploadmedia3/src/Uploadmedia3";
import Subscriptionbilling2 from "../../blocks/subscriptionbilling2/src/Subscriptionbilling2";
import ImportExportData from "../../blocks/importexportdata/src/ImportExportData";
import Chat from "../../blocks/chat/src/Chat";
import ViewChat from "../../blocks/chat/src/ViewChat";
import Notifications from "../../blocks/notifications/src/Notifications";
import Adminconsole2 from "../../blocks/adminconsole2/src/Adminconsole2";
import PhoneNumberInput from "../../blocks/mobile-account-registration/src/PhoneNumberInput";
import AdditionalDetailForm from "../../blocks/mobile-account-registration/src/AdditionalDetailForm";
import Videos from "../../blocks/videos/src/Videos";
import GroupVideoCall from '../../blocks/groupvideocall/src/GroupVideoCall';
import CustomisableUserProfiles from '../../blocks/customisableuserprofiles/src/CustomisableUserProfiles';

import LandingPageWeb from '../../blocks/landingpage/src/LandingPage.web';
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import IncomingCall from "../../blocks/chat/src/IncomingCall.web"
import { initCometChat } from "../../components/src/cometchatService"
import { CustomContextProvider } from "../../components/src/CustomContext.web"
import { initAnalytics } from '../../components/src/utils/googleAnalytics/analyticsAdapter.web';
import { usePageTracking } from '../../components/src/utils/googleAnalytics/usePageTracking.web';

const routeMap = {
AdvancedSearch:{
 component:AdvancedSearch,
path:"/AdvancedSearch"},
Sorting:{
 component:Sorting,
path:"/Sorting"},
Filters:{
  component:Filters,
 path:"/Filters"},
Filteritems:{
 component:Filteritems,
path:"/Filteritems"},
Filteroptions:{
 component:Filteroptions,
path:"/Filteroptions"},
ForgotPassword:{
 component:ForgotPassword,
path:"/ForgotPassword"},
ResetPassword:{
  component:ResetPassword,
 path:"/ResetPassword"},
ForgotPasswordOTP:{
 component:ForgotPasswordOTP,
path:"/ForgotPasswordOTP"},
NewPassword:{
 component:NewPassword,
path:"/NewPassword"},
SocialMediaAccountLogin:{
 component:SocialMediaAccountLogin,
path:"/SocialMediaAccountLogin"},
SocialMediaAccountRegistration:{
 component:SocialMediaAccountRegistration,
path:"/SocialMediaAccountRegistration"},
Rolesandpermissions2:{
 component:Rolesandpermissions2,
path:"/Rolesandpermissions2"},
Cometchatintegration:{
 component:Cometchatintegration,
path:"/Cometchatintegration"},
CountryCodeSelector:{
 component:CountryCodeSelector,
path:"/CountryCodeSelector"},
Contactus:{
 component:Contactus,
path:"/Contactus"},
AddContactus:{
 component:AddContactus,
path:"/AddContactus"},
AboutUs : {
  component:AboutUs,
path:"/AboutUs"
},
Emailnotifications2:{
 component:Emailnotifications2,
path:"/Emailnotifications2"},
MobileAccountLoginBlock:{
 component:MobileAccountLoginBlock,
path:"/MobileAccountLoginBlock"},
MyPlans:{
  component:MyOrders,
 path:"/MyPlans"},
OrderManagement:{
 component:OrderManagement,
path:"/OrderManagement"},
OrderReview:{
  component:OrderReview,
 path:"/OrderReview"},
Settings2:{
 component:Settings2,
path:"/Settings2"},
Pushnotifications:{
 component:Pushnotifications,
path:"/Pushnotifications"},
TermsConditions:{
 component:TermsConditions,
path:"/TermsConditions"},
PrivacyPolicy:{
  component:PrivacyPolicy,
 path:"/PrivacyPolicy"},
TermsConditionsDetail:{
 component:TermsConditionsDetail,
path:"/TermsConditionsDetail"},
TermsConditionsUsers:{
 component:TermsConditionsUsers,
path:"/TermsConditionsUsers"},
LandingPage:{
 component:LandingPage,
path:"/LandingPage"},
AccountGroups:{
 component:AccountGroups,
path:"/AccountGroups"},
NavigationMenu:{
 component:NavigationMenu,
path:"/NavigationMenu"},
EmailAccountRegistration:{
 component:EmailAccountRegistration,
path:"/EmailAccountRegistration"},
EmailVerification:{
 component:EmailVerification,
path:"/EmailVerification"},
OTPInputAuth:{
 component:OTPInputAuth,
path:"/OTPInputAuth"},
Blockedusers:{
 component:Blockedusers,
path:"/Blockedusers"},
AddBlockeduser:{
 component:AddBlockeduser,
path:"/AddBlockeduser"},
GroupVideoCall:{
 component:GroupVideoCall,
path:"/GroupVideoCall"},
BulkUploading:{
 component:BulkUploading,
path:"/BulkUploading"},
SubscriptionPlans:{
  component:SubscriptionPlans,
 path:"/SubscriptionPlans"},
Customisableusersubscriptions:{
 component:Customisableusersubscriptions,
path:"/Customisableusersubscriptions"},
SubscriptionDetails:{
 component:SubscriptionDetails,
path:"/SubscriptionDetails"},
Categoriessubcategories:{
 component:Categoriessubcategories,
path:"/Categoriessubcategories"},
Catalogue:{
 component:Catalogue,
path:"/Catalogue"},
Analytics:{
 component:Analytics,
path:"/Analytics"},
EmailAccountLoginBlock:{
 component:EmailAccountLoginBlock,
path:"/EmailAccountLoginBlock"},
Uploadmedia3:{
 component:Uploadmedia3,
path:"/Uploadmedia3"},
Subscriptionbilling2:{
 component:Subscriptionbilling2,
path:"/Subscriptionbilling2"},
ImportExportData:{
 component:ImportExportData,
path:"/ImportExportData"},
Chat:{
 component:Chat,
path:"/Chat"},
ViewChat:{
 component:ViewChat,
path:"/ViewChat"},
Notifications:{
 component:Notifications,
path:"/Notifications"},
Adminconsole2:{
 component:Adminconsole2,
path:"/Adminconsole2"},
PhoneNumberInput:{
 component:PhoneNumberInput,
path:"/PhoneNumberInput"},
AdditionalDetailForm:{
 component:AdditionalDetailForm,
path:"/AdditionalDetailForm"},
Videos:{
 component:Videos,
path:"/Videos"},

  Home: {
    component: LandingPageWeb,
    path: '/',
    exact: true,
  },
  InfoPage: {
    component: InfoPage,
    path: '/InfoPage',
  },
  CustomisableUserProfiles: {
    component: CustomisableUserProfiles,
    path:'/CustomisableUserProfiles/:username'
  }
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#652784",
    },
  },
  typography: {
    fontFamily: "Montserrat, sans-serif",
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
  },
})

const firebaseAPI = firebase.initializeApp({
  apiKey: 'AIzaSyDgl9aTbKMdRZ9-ijSZRionh3V591gMJl4',
  authDomain: 'rnmasterapp-c11e9.firebaseapp.com',
  databaseURL: 'https://rnmasterapp-c11e9.firebaseio.com',
  projectId: 'rnmasterapp-c11e9',
  storageBucket: 'rnmasterapp-c11e9.appspot.com',
  messagingSenderId: '649592030497',
  appId: '1:649592030497:web:7728bee3f2baef208daa60',
  measurementId: 'G-FYBCF3Z2W3',
});

const defaultAnalytics = firebaseAPI.analytics();
defaultAnalytics.logEvent('APP_Loaded');

function App() {
  React.useEffect(() => {
    initCometChat();
    initAnalytics()
  }, []);

  usePageTracking()

  return (
      <BuilderProvider>
        <View style={{ height: "100dvh" }}>
          <ThemeProvider theme={theme}>
            <CustomContextProvider>
              <CssBaseline />
              <IncomingCall />
              <WebRoutesGenerator routeMap={routeMap} />
              <Outlet />
              <AlertBlock />
            </CustomContextProvider>
          </ThemeProvider>
        </View>
      </BuilderProvider>
  );
}

export default App;